<template>
  <div
    class="course-categories"
    :class="{
      'electron-course-categories': isElectron,
    }"
  >
    <!-- 课程分类 -->
    <div class="categories-wrap-box">
      <ul v-if="categories.length" class="categories-wrap">
        <li
          v-for="(item, index) in categories"
          :key="index"
          class="categories-item"
          @click="jumpCategory(item)"
        >
          <img :src="item.image" alt="" />
          <p class="name">{{ item.name }}</p>
        </li>
      </ul>
      <img
        class="settle-img"
        :src="settleImg"
        @click="handleClickSettle"
        alt=""
      />
    </div>

    <!-- 推荐 -->
    <!-- <ul v-if="recommenList.length" class="recommenList-wrap">
      <li
        v-for="(item, index) in recommenList"
        :key="index"
        class="recommenList-item"
        @click="jumpUrl(item)"
      >
        <div class="info-wrap">
          <p class="name">{{ item.name }}</p>
          <p class="info">{{ item.info }}</p>
        </div>
        <img :src="item.image" alt="" />
      </li>
      <li
        v-if="!isElectron"
        class="download-item-wrap"
        @click="jumpUrl(downloadItem)"
      >
        <div class="download-item">
          <div class="info-wrap">
            <p class="name">{{ downloadItem.name }}</p>
            <p class="info">{{ downloadItem.info }}</p>
          </div>
          <img src="../../../assets/images/home/logo-img.png" alt="" />
        </div>
        <div class="download-hover">
          <img src="../../../assets/images/home/download-icon.png" alt="" />
          <span>立即下载</span>
        </div>
      </li>
    </ul> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { fastCreateOrganization } from "@saas/server-api/src/organization";
export default {
  data: function () {
    return {
      isElectron: false,
      categories: [
        {
          name: "公考",
          image: require("../../../assets/images/home/public-exam.png"),
        },
        {
          name: "教资教招",
          image: require("../../../assets/images/home/postgraduate.png"),
        },
        {
          name: "考研",
          image: require("../../../assets/images/home/career-certification.png"),
        },
        {
          name: "财会金融",
          image: require("../../../assets/images/home/design.png"),
        },
        {
          name: "设计制作",
          image: require("../../../assets/images/home/design-1.png"),
        },
        {
          name: "IT互联网",
          image: require("../../../assets/images/home/IT-icon.png"),
        },
        {
          name: "求职面试",
          image: require("../../../assets/images/home/job.png"),
        },
        {
          name: "个人提升",
          image: require("../../../assets/images/home/language.png"),
        },
      ],
      recommenList: [
        {
          name: "商业设计全科班",
          info: "写实插画系统课程",
          image: require("../../../assets/images/home/recommen-img1.png"),
        },
        {
          name: "手绘插画全科班",
          info: "写实插画系统课程",
          image: require("../../../assets/images/home/recommen-img2.png"),
        },
        {
          name: "全能流利英语直播",
          info: "写实插画系统课程",
          image: require("../../../assets/images/home/recommen-img3.png"),
        },
      ],
      downloadItem: {
        name: "下载魔果云课客户端",
        info: "硕学丰收，为梦想加速",
        type: "download",
      },
      settleImg: process.env.VUE_APP_CDN_URL + "/cdn/static/images/settle.png",
      adminUrl: process.env.VUE_APP_ADMIN_URL,
      settleUrl: process.env.VUE_APP_SAAS_WEB_URL + "/org-settled",
    };
  },
  created() {
    this.isElectron = window.isElectron;
  },
  computed: {
    ...mapGetters(["isAuthenticated", "user"]),
    isSettle() {
      return this.user && this.user.org_id;
    },
  },
  methods: {
    jumpUrl(item) {
      if (item.type === "download") {
        let url = `/download`;
        if (window.isElectron) {
          this.$router.push(url);
        } else {
          window.open(url);
        }
      }
    },
    backgroud(item) {
      if (item.backgroud) {
        return {
          background: item.backgroud,
        };
      } else {
        return {};
      }
    },
    jumpCategory(item) {
      if (this.isElectron) {
        this.$router.push(`/search-result?keyword=${item.name}`);
      } else {
        window.open(`/search-result?keyword=${item.name}`);
      }
    },
    handleClickSettle() {
      if (this.isAuthenticated && this.isSettle) {
        // 已登录且已入驻跳转机构后台
        this.openAdmin();
      } else if (this.isAuthenticated && !this.isSettle) {
        // 已登录且未入驻,创建机构  后跳转机构后台
        fastCreateOrganization()
          .then((res) => {
            if (res.code === 1) {
              this.openAdmin();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(() => {
            this.$message.error("机构创建失败，请稍后重试");
          });
      } else {
        // 未登录跳转机构入驻引导页
        this.openSettle();
      }
    },
    openSettle() {
      if (this.isElectron) {
        window.openUrlByExternal(this.settleUrl);
      } else {
        this.$router.push("/org-settled");
      }
    },
    openAdmin() {
      if (this.isElectron) {
        window.openUrlByExternal(this.adminUrl);
      } else {
        window.open(this.adminUrl, "_blank");
      }
    },
  },
};
``;
</script>

<style lang="scss" scoped>
.course-categories {
  // padding-top: 20px;
  padding: 20px 18px 16px 18px;
  .categories-wrap-box {
    display: flex;
    justify-content: space-between;
    .settle-img {
      width: 420px;
      height: 300px;
      cursor: pointer;
    }
  }
  .categories-wrap {
    display: flex;
    flex-wrap: wrap;
    width: 688px;
    gap: 0 60px;
    // padding-bottom: 60px;
    justify-content: space-between;
    align-content: space-between;
    .categories-item {
      width: 90px;
      cursor: pointer;
      // margin-bottom: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 100px;
        height: 100px;
        margin-bottom: 12px;
      }
      .name {
        font-weight: 500;
        font-size: 18px;
        color: $saas-text-color;
        line-height: 25px;
      }
    }
  }
  .recommenList-wrap {
    width: 1200px;
    margin-bottom: 24px;
    display: flex;
    .recommenList-item {
      cursor: pointer;
      width: 268px;
      height: 87px;
      background: #f0fffb;
      border-radius: 16px;
      padding: 0 8px 0 20px;
      display: flex;
      justify-content: space-between;
      margin-right: 42.5px;
      align-items: center;
      .info-wrap {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .name {
          font-weight: 500;
          font-size: 18px;
          color: $saas-text-color;
          line-height: 25px;
          margin-bottom: 4px;
        }
        .info {
          font-size: 14px;
          color: #888988;
          line-height: 20px;
        }
      }
      img {
        width: 80px;
        height: 80px;
      }
    }
    .download-item-wrap {
      position: relative;
      overflow: hidden;
      width: 268px;
      height: 87px;
      cursor: pointer;
      background: linear-gradient(
        132deg,
        rgba($color: $linear-gradient-begin, $alpha: 0.2) 0%,
        rgba($color: $linear-gradient-end, $alpha: 0.2) 100%
      );
      border: 2px solid transparent;
      border-radius: 16px;
      transition: all 0.2s;
    }
    .download-item {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      opacity: 1;
      margin-right: 0;
      padding: 0 26px 0 20px;
      .info-wrap {
        display: flex;
        flex-direction: column;
        .name {
          font-weight: 500;
          font-size: 18px;
          color: $saas-text-color;
          line-height: 25px;
          margin-bottom: 4px;
        }
        .info {
          font-size: 14px;
          color: #888988;
          line-height: 20px;
        }
      }
      img {
        width: 39px;
        height: 39px;
      }
      transition: all 0.2s;
    }
    .download-item-wrap:hover {
      border: 2px solid $saas-border-color;
      .download-item {
        opacity: 0;
        transform: scale(0);
      }
      .download-hover {
        opacity: 1;
        transform: scale(1);
      }
    }
    .download-hover {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 22px;
        height: 22px;
        margin-bottom: 6px;
      }
      span {
        font-weight: 500;
        font-size: 18px;
        color: $saas-text-color;
        line-height: 25px;
      }
      transition: all 0.2s;
    }
  }
}

.course-categories.electron-course-categories {
  padding-top: 0px;
  margin-bottom: 4px;
  .categories-item {
    width: 90px;
    img {
      width: 70px;
      height: 70px;
      margin-bottom: 0;
    }
    .name {
      font-weight: 500;
      font-size: 14px;
      color: #0d1400;
      line-height: 20px;
    }
  }
  .recommenList-wrap {
    width: 100%;
    margin-bottom: 0;
    .recommenList-item {
      width: 210px;
      height: 60px;
      border-radius: 12px;
      padding: 0 14px 0 14px;
      margin-right: 40px;
    }
    .info-wrap {
      .name {
        font-weight: 500;
        font-size: 14px;
        color: #0d1400;
        line-height: 20px;
        margin-bottom: 3px;
      }
      .info {
        font-weight: 400;
        font-size: 12px;
        color: #888988;
        line-height: 17px;
      }
    }
    img {
      width: 42px;
      height: 42px;
    }
  }
  .categories-wrap-box {
    margin-top: 20px;
    gap: 0 20px;
  }
  .settle-img {
    width: 280px;
    height: 200px;
    cursor: pointer;
  }
}
</style>
